
import React from "react";
import { Loader2, AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const LoadingState = () => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12">
        <Loader2 className="h-12 w-12 animate-spin text-luijten-red mb-4" />
        <p className="text-lg font-medium">Melding laden...</p>
      </CardContent>
    </Card>
  );
};

export const ErrorState = ({ error }: { error: Error }) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12">
        <AlertCircle className="h-12 w-12 text-red-500 mb-4" />
        <p className="text-lg font-medium text-red-500">
          Er is een fout opgetreden bij het laden van de melding
        </p>
        <p className="text-sm text-muted-foreground mt-2">{error.message}</p>
      </CardContent>
    </Card>
  );
};
